import React from "react";
import { useRecordContext } from "react-admin";
import {
    Chip,
    Link,
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { formatDateTime } from "../../utils/DateTimeUtils";
import {
    CustomTableRowTR,
    StyledTable,
    TableData,
    TableHeader,
    TableTopHeader,
    TableWrapper,
    Title,
} from "../../styles/commonStyles";

const getStatusChipStyles = (status?: string) => {
    switch ((status || "").toUpperCase()) {
        case "SUCCESS":
        case "PROCESSED":
            return { color: "#047857", background: "rgba(16, 185, 129, 0.16)" };
        case "PENDING":
            return { color: "#B45309", background: "rgba(245, 158, 11, 0.18)" };
        case "FAILED":
            return { color: "#B91C1C", background: "rgba(239, 68, 68, 0.16)" };
        default:
            return { color: "#6B7280", background: "rgba(107, 114, 128, 0.16)" };
    }
};

const ComboRefundsTab = () => {
    const record = useRecordContext<any>();
    const refunds: any[] = Array.isArray(record?.refundData) ? record.refundData : [];

    return (
        <TableWrapper>
            <TableTopHeader>
                <Title>Refunds</Title>
            </TableTopHeader>
            <TableContainer
                component={Paper}
                sx={{
                    borderRadius: 2,
                    overflowX: "auto",
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                }}
            >
                <StyledTable size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "rgba(232, 235, 237, 0.3) !important" }}>
                            <TableHeader>ID</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Amount</TableHeader>
                            <TableHeader>Type</TableHeader>
                            <TableHeader>Refunded By</TableHeader>
                            <TableHeader>Refund Processed At</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {refunds.length > 0 ? (
                            refunds.map((refund) => (
                                <CustomTableRowTR key={refund.id}>
                                    <TableData>{refund.id ?? "-"}</TableData>
                                    <TableData>
                                        <Chip
                                            label={refund.status || "-"}
                                            size="small"
                                            sx={{
                                                ...getStatusChipStyles(refund.status),
                                                fontWeight: 600,
                                            }}
                                        />
                                    </TableData>
                                    <TableData>{refund.amount ?? "-"}</TableData>
                                    <TableData>{refund.refundType ?? "-"}</TableData>
                                    <TableData>
                                        {refund.refundedBy ? (
                                            <Link
                                                href={`/#/AdminUsers/${refund.refundedBy}/show`}
                                                underline="hover"
                                            >
                                                {refund.refundedBy}
                                            </Link>
                                        ) : (
                                            "-"
                                        )}
                                    </TableData>
                                    <TableData>
                                        <span style={{ whiteSpace: 'nowrap' }}>
                                            {refund.refundProcessedAt ? formatDateTime(refund.refundProcessedAt) : "-"}
                                        </span>
                                    </TableData>
                                </CustomTableRowTR>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                    No refunds found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </StyledTable>
            </TableContainer>
        </TableWrapper>
    );
};

export default ComboRefundsTab;
